










import { Vue, Component } from 'vue-property-decorator';
import LoadingService from './loading.service';

@Component({})
export default class LoadingComponent extends Vue {
  // eslint-disable-next-line class-methods-use-this
  get isShow() {
    return LoadingService.isShow;
  }
}

export { LoadingComponent as VbLoadingComponent };
